import { useMainContext } from '@contexts/Contexts';
import Talk from '@components/Talk/Talk';
import classNames from 'classnames';

const TalkList = () => {
	const { filteredTalks, selectedCatsTags } = useMainContext().state;

	const classes = classNames(
		'cfs-talk-list',
		selectedCatsTags.length > 0 ? 'cfs-talk-list--filtered' : '',
	);
	return (
		<div className={classes}>
			{filteredTalks &&
				filteredTalks.map((talk, index) => (
					<Talk key={index} talk={talk} />
				))}
		</div>
	);
};

export default TalkList;
